var _desc, _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddLocation634(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add Location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.8,
    strokeMiterlimit: 10,
    stroke: "currentColor",
    fill: "none",
    d: "M40.6 31a30.9 30.9 0 0 0 1.4-9 20 20 0 0 0-40 0c0 18 20 38 20 38a95.3 95.3 0 0 0 8.5-10.1",
    "data-name": "layer2",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 2.8,
    strokeMiterlimit: 10,
    stroke: "currentColor",
    fill: "none",
    r: 6,
    cy: 22,
    cx: 22,
    "data-name": "layer2",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 2.8,
    strokeMiterlimit: 10,
    stroke: "currentColor",
    fill: "none",
    r: 16,
    cy: 46,
    cx: 46,
    "data-name": "layer1",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v16m-8-8h16",
    strokeWidth: 2.8,
    strokeMiterlimit: 10,
    stroke: "currentColor",
    fill: "none",
    "data-name": "layer1",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLocation634);
export default __webpack_public_path__ + "static/media/add-location-634.d2ac90beb7e7eee1a2d44662cdb01bbc.svg";
export { ForwardRef as ReactComponent };